<span class="title-section">En esta sección:</span>
<nav aria-label="Tabla de contenido de esta sección">
  <ul>
    <li class="nav-item" *ngFor="let item of content">
      <a [class]="'nav-link first-level' + (item.id === currentCategory ? ' active' : '')" [attr.aria-current]="item.id === currentCategory ? 'page' : undefined" [href]="urlComponent + '#' + item.id">
        {{item.nombre}}
      </a>
      <ul *ngIf="item.subItems">
        <li class="nav-item" *ngFor="let subItem of item.subItems">
          <a [class]="'nav-link second-level' + (subItem.id === currentCategory ? ' active' : '') + (subItem.subItems?.length > 0 ? ' activeSubItem' : '')" [attr.aria-current]="subItem.id === currentCategory ? 'page' : undefined" [href]="urlComponent + '#' + subItem.id">
            {{subItem.nombre}}
          </a>
          <ul *ngIf="subItem.subItems">
            <li class="nav-item" *ngFor="let subItemItem of subItem.subItems">
              <a [class]="'nav-link third-level' + (subItemItem.id === currentCategory ? ' active' : '')" [attr.aria-current]="subItemItem.id === currentCategory ? 'page' : undefined" [href]="urlComponent + '#' + subItemItem.id">
                {{subItemItem.nombre}}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</nav>
